import { render, staticRenderFns } from "./Our_priority.vue?vue&type=template&id=d946eec6&scoped=true"
import script from "./Our_priority.vue?vue&type=script&lang=js"
export * from "./Our_priority.vue?vue&type=script&lang=js"
import style0 from "./Our_priority.vue?vue&type=style&index=0&id=d946eec6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d946eec6",
  null
  
)

export default component.exports